export default {
	// Deviceの一覧
	getDevices() {
		let devices = {
			"videoinput": [],
			"audioinput": [],
			"audiooutput": [],
		}
		if (
			!navigator.mediaDevices ||
			navigator.mediaDevices.getUserMedia === undefined ||
			navigator.mediaDevices.enumerateDevices === undefined
		) {
			console.log("no USERMEDIA")
			return null;
		}

		// 接続できるデバイスを渡す
		navigator.mediaDevices.enumerateDevices().then(function (sourcesInfo) {
			for (let i in sourcesInfo) {
				let d = {
					deviceId: sourcesInfo[i].deviceId,
					label: sourcesInfo[i].label
				}
				if (!devices[sourcesInfo[i].kind]) {
					devices[sourcesInfo[i].kind] = [];
				}
				if (!d.label || d.label == "") {
					d.label = sourcesInfo[i].kind + "_" + (devices[sourcesInfo[i].kind].length + 1);
				}
				devices[sourcesInfo[i].kind].push(d);
			}
		});

		return devices;
	},
	getResolutions() {
		return [
			{ id: "low", label: "Low", width: { ideal: 640 } },
			{ id: "normal", label: "Normal", width: { ideal: 1280 } },
			{ id: "high", label: "High", width: { ideal: 1920 } }
		]
	},
	createVideo() {

	},
	startVideo(param) {
		const soraData = param.soraData;
		const videoOtherAreaDom = param.videoOtherAreaDom;
		const roomData = param.roomData;

		const debug = false;

		console.log("startVideo");

		// 接続してるものがあったら削除
		if (param.publisher) {
			param.publisher.disconnect();
		}
		// 他の接続してるビデオを削除
		videoOtherAreaDom.innerHTML = "";

		//接続するwssがセキュアなものがあればそちらを優先
		let sorawspath = soraData.sora.sora_server_ssl_uri;
		if (!sorawspath) {
			sorawspath = soraData.sora.sora_api_uri;
		}
		// 接続のための情報
		const metadata = {
			user_id: soraData.sora.user_id,
			id: soraData.setting.id,
			key: soraData.setting.key,
			room_name: roomData.name
		}
		// マルチストリームで相互にやりとりする
		const options = {
			multistream: true,
			// spotlight: 2
			videoCodecType: param.soraCodec
		}

		console.log("SORA CONNECT");
		const sora = Sora.connection(sorawspath, debug);

		param.publisher = sora.sendrecv(roomData.id, metadata, options);
		// 書き出したものが実行された場合



		param.publisher.on('addstream', function (event) {
			console.log('>>>> addstream');

			let domId = 'pub-remote-' + event.stream.id;
			// 同一のstreamIdが来る場合があるので古いものは削除
			const sameStream = document.getElementById(domId);
			if (sameStream) {
				if (param.videoMainDom.dataset.videoid == domId) {
					param.videoMainDom.dataset.videoid = "-";
					param.videoMainDom.srcObject = null;
				}
				videoOtherAreaDom.removeChild(document.getElementById(domId));
			}

			const videoRemote = document.createElement('video');
			videoRemote.id = domId;
			videoRemote.style.border = '1px solid black';
			videoRemote.playsinline = true;
			videoRemote.autoplay = true;
			videoRemote.width = '160';
			videoRemote.height = '120';
			videoRemote.addEventListener('click', function (e) {
				if (param.onclick) param.onclick.call(null, this);
			})

			videoRemote.srcObject = event.stream;
			videoRemote.dataset.othervideo = 1;
			videoRemote.play();
			videoRemote.addEventListener("ended", () => {
				videoOtherAreaDom.removeChild(videoRemote);
			})

			videoOtherAreaDom.appendChild(videoRemote);

			// 1つめの場合は強制選択状態
			if (videoOtherAreaDom.childNodes.length == 1 || param.videoMainDom.dataset.videoid == "-") {
				console.log("---- CHANGE MAIN");
				videoRemote.style.display = "none";

				param.videoMainDom.playsinline = true;
				param.videoMainDom.autoplay = true;
				param.videoMainDom.srcObject = event.stream;
				param.videoMainDom.dataset.videoid = videoRemote.id;
				param.videoMainDom.play();

			}

		});
		// 書き出したのが終了した場合
		param.publisher.on('removestream', function (event) {
			// console.log('>>>>> removestream');

			let domId = 'pub-remote-' + event.stream.id;
			// メインに設定してるものだとmainも削除
			if (param.videoMainDom.dataset.videoid == domId) {
				param.videoMainDom.dataset.videoid = "-";
				param.videoMainDom.srcObject = null;
			}
			videoOtherAreaDom.removeChild(document.getElementById(domId));
		});

		param.publisher.on('removetrack', function (e) {
			console.log("------ removetrack");
			console.log(e);
		});
		param.publisher.on('track', function (e) {
			console.log("------ track");
			console.log(e);
		});
		param.publisher.on('timeout', function (e) {
			console.log("----timeout");
			param.onpush(e);
		});

		param.publisher.on('disconnect', function (e) {
			console.log("publisher disconnect");
			console.log(e);
		});
		param.publisher.on('push', function (d) {
			console.log("----push");
			param.onpush(d);
		});


		param.publisher.on('notify', function (e) {
			// 接続中は常時イベント発生
			// {
			// 	event_type: "network.status"
			// 	type: "notify"
			// 	unstable_level: 0
			// }
			// console.log("publisher notify");
			// console.log(e);
		});
		param.publisher.on('log', function (e) {
			// 接続のステータス取得
			// console.log("publisher log");
			// console.log(e);
		});

		// param.subscriber = sora.subscriber(roomData.id, metadata, options);
		// param.subscriber.on('disconnect', function (e) {
		// 	console.log("subscriber disconnect");
		// 	console.log(e);
		// })
		// param.subscriber.on('push', function (e) {
		// 	console.log("subscriber push");
		// 	console.log(e);
		// })
		// param.subscriber.on('addstream', function (e) {
		// 	console.log("subscriber addstream");
		// 	console.log(e);
		// })
		// param.subscriber.on('removestream', function (e) {
		// 	console.log("subscriber removestream");
		// 	console.log(e);
		// })
		// param.subscriber.on('notify', function (e) {
		// 	console.log("subscriber notify");
		// 	console.log(e);
		// })
		// param.subscriber.on('log', function (e) {
		// 	console.log("subscriber log");
		// 	console.log(e);
		// })

		this.startGetusermedia({
			setting: param.setting,
			publisher: param.publisher,
			targetDom: param.videoSelfDom,
			returnFunc: param.returnFunc
		});
		return { "publisher": param.publisher };

	},
	startGetusermedia(param) {

		if (!param.targetDom) {
			return;
		}

		let setting = param.setting;
		if (!setting) setting = {};

		// 映像と音声のセッティングを作成
		let videoSetting = {};
		let audioSetting = {};
		// 解像度があれば
		if (setting.resolution) {
			let l = this.getResolutions().filter(function (v) {
				return v.id === setting.resolution;
			})
			if (l.length > 0) {
				videoSetting.width = l[0].width;
			}
		}
		// ビデオ指定があれば
		if (setting.video) {
			videoSetting.deviceId = setting.video;
		} else {
			videoSetting = true;
		}
		// 音の指定があれば
		if (setting.audio) {
			audioSetting.deviceId = setting.audio;
		} else {
			audioSetting = true;
		}

		let constraints = {
			video: videoSetting,
			audio: audioSetting
		};

		if (param.targetDom && param.targetDom.srcObject) {
			if (param.targetDom.srcObject.getTracks()) {
				for (const t of param.targetDom.srcObject.getTracks()) {
					t.enabled = false;
					t.stop();
				}
			}
			param.targetDom.srcObject = null;
		}


		navigator.mediaDevices.getUserMedia(constraints).then(function (mediaStream) {
			// soraにvideoを渡す
			if (param.publisher) {
				param.publisher.connect(mediaStream)
					.then(stream => {
						// videoを表示する
						param.targetDom.playsinline = true;
						param.targetDom.autoplay = true;
						param.targetDom.muted = true;
						param.targetDom.srcObject = stream;
						// param.targetDom.play();
						mediaStream.videoEnabled = false;

						if (param.returnFunc) {
							param.returnFunc.call(null, { "error": false, "mediaStream": stream });
						}
					}).catch(e => {
						console.log(e);
					});
			} else {
				param.targetDom.playsinline = true;
				param.targetDom.autoplay = true;
				param.targetDom.muted = true;
				param.targetDom.srcObject = mediaStream;
				if (param.returnFunc) {
					param.returnFunc.call(null);
				}
			}
		}).catch((e) => {
			param.targetDom.srcObject = null;
			console.log("error:" + e);
			alert("カメラが許可されていないか設定が対応していません。設定を見直してください。");
		})

		return { "publisher": param.publisher };
	}

}


// WEBPACK FOOTER //
// ./src/api/usermedia.js